module.exports = __webpack_public_path__ + "static/media/mail-white.2beac898.svg";